export default class FormAnswered {
  constructor(resource) {
    this._resource = resource;
  }

  async finishReservationByAdm(data) {
    return await this._resource(`finishReservationByAdm/v2/`).save(data);
  }

  async getCurrentReservationValue(vehicleRequestId) {
    return await this._resource(
      `formAnswered/vehicleRequest/getCurrentReservationValue/${vehicleRequestId}`
    ).get();
  }

  async getByVehicleRequestId(vehicleRequest) {
    let result = null;
    try {
      let response = await this._resource(
        `formAnswered/vehicleRequest/${vehicleRequest.id}`
      ).get();
      result = {
        ok: response.ok,
        data: response.body,
      };
    } catch (error) {
      result = {
        ok: false,
        message: error.body.message,
      };
    }
    return result;
  }

  async uploadFiles(data) {
    let result = null;
    try {
      let response = await this._resource(`formAnswered`).save(data);
      result = {
        ok: response.ok,
        message: response.body.message,
      };
    } catch (error) {
      result = {
        ok: false,
        message: error.body.message,
      };
    }
    return result;
  }

  async newRegister(data) {
    return await this._resource(`newFormAnswered`)
      .save(data)
      .then(res => res.body)
      .catch(error => {
        throw error;
      });
  }

  async uploadPhotos(data) {
    return await this._resource(`formAnswered/photo`)
      .save(data)
      .then(res => res.body)
      .catch(e => {
        throw e;
      });
  }

  async findFormFieldByVehicleRequestId(data) {
    let response = null;
    try {
      let result = await this._resource(`formField/${data}`).get();
      response = {
        ok: result.ok,
        data: result.body.map(i => {
          return {
            form_field_id: i.id,
            defaultImage: i.default,
            stepName: i.description,
          };
        }),
      };
    } catch (error) {
      response = {
        ok: false,
        message: error,
      };
    }
    return response;
  }

  async forceChangeStep(vehicleRequestId, formImages) {
    return await this._resource(`forceChangeStep/v2/${vehicleRequestId}`).save(
      formImages
    );
  }
}
